export class Parking {
    constructor(id, clientId, plate, zoneId, email, parkingDate, contactPhone, coordinates) {
        this.id = id;
        this.clientId = clientId;
        this.plate = plate;
        this.zoneId = zoneId;
        this.email = email;
        this.parkingDate = parkingDate;
        this.contactPhone = contactPhone;
        this.coordinates = coordinates;
    }
    validate() {
        if (!this.clientId ||
            !this.contactPhone ||
            !this.plate ||
            !this.zoneId) {
            return false;
        }
        return true;
    }
}
